import React, { Component } from "react";

export default class ModernTabBackgroundItem extends Component {
  render() {
    return (
      <li
        className={`${
          this.props.activePartsTab === "modern_background" ? "active" : ""
        } ${this.props.themeDirection === "ltr" ? "item-EN" : ""}`}
        onClick={() => {
          this.props.partsTabHandler("modern_background");
        }}
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 34 23"
          version="1.1"
          style={{ backgroundColor: "#ffffff", padding: "1px 2px" }}
        >
          <g transform="matrix(1,0,0,1,-2819.93,-3001.49)">
            <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
              <g transform="matrix(0.0399722,0,8.11535e-34,0.04245,7722.17,130.487)">
                <rect
                  x="524.416"
                  y="441.142"
                  width="707.127"
                  height="406.676"
                  style={{
                    fill: "rgb(222,42,53)",
                    stroke: "rgb(222,42,53)",
                    strokeWidth: "24.25px",
                  }}
                />
              </g>
            </g>
          </g>
        </svg>
        <span>{this.props.texts["background"]}</span>
      </li>
    );
  }
}
